document.addEventListener('DOMContentLoaded', function () {
    /* Mega Nav Hover */
    var hoverMegaNav;
    
    // Helper functions
    function addClass(elements, className) {
        if (elements) {
            if (elements.length !== undefined) {
                elements.forEach(el => el.classList.add(className));
            } else {
                elements.classList.add(className);
            }
        }
    }
    
    function removeClass(elements, className) {
        if (elements) {
            if (elements.length !== undefined) {
                elements.forEach(el => el.classList.remove(className));
            } else {
                elements.classList.remove(className);
            }
        }
    }
    
    function hasClass(element, className) {
        return element && element.classList.contains(className);
    }
    
    function closest(element, selector) {
        return element ? element.closest(selector) : null;
    }
    
    function getAttribute(element, attr) {
        return element ? element.getAttribute(attr) : null;
    }
    
    function setAttribute(element, attr, value) {
        if (element) element.setAttribute(attr, value);
    }
    
    function getDataAttribute(element, attr) {
        return element ? element.dataset[attr] : null;
    }
    
    function triggerEvent(element, eventType) {
        if (element) {
            const event = new Event(eventType, { bubbles: true });
            element.dispatchEvent(event);
        }
    }
    
    // Doen header mouseenter
    document.querySelectorAll('.doen-header').forEach(header => {
        header.addEventListener('mouseenter', function (e) {
            e.stopPropagation();
            clearTimeout(hoverMegaNav);
            const handle = getDataAttribute(this, 'handle');
            const megaNavs = document.querySelectorAll('.doen-meganav:not([data-trigger="' + handle + '"])');
            removeClass(megaNavs, 'active');
            removeClass(document.body, 'mega-nav-overlay');
            addClass(document.querySelectorAll('.doen-header'), 'hover');
            const targetMegaNav = document.querySelector('.doen-meganav[data-trigger="' + handle + '"]');
            if (targetMegaNav) {
                addClass(targetMegaNav, 'active');
                addClass(document.body, 'mega-nav-overlay');
            }
        });
    });

    document.querySelectorAll('.doen-header').forEach(header => {
        header.addEventListener('mouseleave', function (e) {
            hoverMegaNav = setTimeout(function () {
                removeClass(document.querySelectorAll('.doen-meganav'), 'active');
                document.querySelectorAll('.nav-item__link.open-mega-nav').forEach(el => setAttribute(el, 'aria-expanded', "false"));
                removeClass(document.body, 'mega-nav-overlay');
                removeClass(document.body, 'mega-nav-switching');

                const doenHeader = document.querySelector('.doen-header');
                if (!hasClass(doenHeader, 'sticky')) {
                    removeClass(document.querySelectorAll('.doen-header'), 'hover');
                }
            }, 250);
        });
    });

    document.querySelectorAll('.doen-header .nav-item__link[data-handle="New"]').forEach(link => {
        link.addEventListener('mouseenter', function (e) {
            hoverMegaNav = setTimeout(function () {
                removeClass(document.querySelectorAll('.doen-meganav'), 'active');
                document.querySelectorAll('.nav-item__link.open-mega-nav').forEach(el => setAttribute(el, 'aria-expanded', "false"));
                removeClass(document.body, 'mega-nav-overlay');
                removeClass(document.body, 'mega-nav-switching');

                const doenHeader = document.querySelector('.doen-header');
                if (!hasClass(doenHeader, 'sticky')) {
                    removeClass(document.querySelectorAll('.doen-header'), 'hover');
                }
            }, 250);
        });
    });

    document.querySelectorAll('.doen-header a.open-mega-nav').forEach(link => {
        link.addEventListener('mouseenter', function (e) {
            e.stopPropagation();
            clearTimeout(hoverMegaNav);
            const activeMegaNav = document.querySelector('.doen-meganav.active');
            if (activeMegaNav) {
                addClass(document.body, 'mega-nav-switching');
                const handle = getDataAttribute(this, 'handle');
                const megaNavs = document.querySelectorAll('.doen-meganav:not([data-trigger="' + handle + '"])');
                removeClass(megaNavs, 'active');
                document.querySelectorAll('.nav-item__link.open-mega-nav').forEach(el => setAttribute(el, 'aria-expanded', "false"));
            }
            removeClass(document.body, 'mega-nav-overlay');
            addClass(document.querySelectorAll('.doen-header'), 'hover');
            const handle = getDataAttribute(this, 'handle');
            const targetMegaNav = document.querySelector('.doen-meganav[data-trigger="' + handle + '"]');
            if (targetMegaNav) {
                addClass(targetMegaNav, 'active');
                setAttribute(this, 'aria-expanded', "true");
                targetMegaNav.focus();
                addClass(document.body, 'mega-nav-overlay');
            }
        });
    });

    document.querySelectorAll('.doen-header a.open-mega-nav').forEach(link => {
        link.addEventListener('keydown', function (e) {
            if (e.key === 'Space' || e.key === 'Enter') {
                e.preventDefault();
                if (getAttribute(this, 'aria-expanded') == "true") {
                    triggerEvent(this, 'mouseleave');
                } else {
                    triggerEvent(this, 'mouseenter');
                }
            }
        });
    });

    document.querySelectorAll('.doen-header a.open-mega-nav').forEach(link => {
        link.addEventListener('click', function (e) {
            if (getAttribute(this, 'href') == "" || getAttribute(this, 'href') == "#") {
                e.preventDefault();

                if (getAttribute(this, 'aria-expanded') == "true") {
                    triggerEvent(this, 'mouseleave');
                } else {
                    triggerEvent(this, 'mouseenter');
                }
            }
        });
    });

    window.addEventListener('keydown', function (e) {
        const focusedOpenMegaNav = document.querySelector('a.open-mega-nav:focus');

        if (e.keyCode == 32 && focusedOpenMegaNav) {
            e.preventDefault();

            if (getAttribute(focusedOpenMegaNav, 'aria-expanded') == "true") {
                triggerEvent(focusedOpenMegaNav, 'mouseleave');
            } else {
                triggerEvent(focusedOpenMegaNav, 'mouseenter');
            }
        }
    });

    document.querySelectorAll('.doen-meganav').forEach(megaNav => {
        megaNav.addEventListener('mouseenter', function (e) {
            e.stopPropagation();
            clearTimeout(hoverMegaNav);
            const otherMegaNavs = document.querySelectorAll('.doen-meganav');
            otherMegaNavs.forEach(nav => {
                if (nav !== this) removeClass(nav, 'active');
            });
            removeClass(document.querySelectorAll('a.open-mega-nav'), 'active');
            addClass(this, 'active');
            addClass(document.body, 'mega-nav-overlay');
            addClass(document.querySelectorAll('.doen-header'), 'hover');
            const trigger = getDataAttribute(this, 'trigger');
            const targetLink = document.querySelector('a.open-mega-nav[data-handle="' + trigger + '"]');
            if (targetLink) addClass(targetLink, 'active');
        });
    });

    document.querySelectorAll('.doen-meganav').forEach(megaNav => {
        megaNav.addEventListener('mouseleave', function (e) {
            e.stopPropagation();
            hoverMegaNav = setTimeout(function () {
                removeClass(document.querySelectorAll('a.open-mega-nav'), 'active');
                removeClass(document.querySelectorAll('.doen-meganav'), 'active');
                document.querySelectorAll('.nav-item__link.open-mega-nav').forEach(el => setAttribute(el, 'aria-expanded', "false"));
                removeClass(document.body, 'mega-nav-overlay');
                removeClass(document.body, 'mega-nav-switching');

                const doenHeader = document.querySelector('.doen-header');
                if (!hasClass(doenHeader, 'sticky')) {
                    removeClass(document.querySelectorAll('.doen-header'), 'hover');
                }
            }, 250);
        });
    });
    /* END Mega Nav Hover */

    document.querySelectorAll('.doen-meganav__sub-nav-toggle').forEach(toggle => {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            const subNav = closest(this, '.doen-meganav__sub-nav');
            const link = subNav ? subNav.querySelector('.doen-sub-nav__link') : null;

            if (link && !hasClass(link, 'open')) {
                addClass(link, 'open');
                setAttribute(link, 'aria-expanded', "true");
            } else if (link) {
                removeClass(link, 'open');
                setAttribute(link, 'aria-expanded', "false");
            }
        });
    });

    const subnav = document.querySelector('.doen-meganav__sub-nav');
    const subnavList = document.querySelector('.doen-sub-nav__list');

    if (subnav) {
        if (subnavList) subnavList.style.display = 'none';
        const navItem = closest(subnav, '.nav-item');
        const nav = navItem ? navItem.querySelector('.doen-meganav') : null;

        if (nav) {
            const navHeight = nav.offsetHeight + parseInt(getComputedStyle(nav).marginTop) + parseInt(getComputedStyle(nav).marginBottom);
            const subnavHeight = subnav.offsetHeight + parseInt(getComputedStyle(subnav).marginTop) + parseInt(getComputedStyle(subnav).marginBottom);
            nav.style.minHeight = (navHeight + subnavHeight + 3) + 'px';
        }
    }

    const doenHeader = document.querySelector('.doen-header');
    const body = document.body;

    let collectionBanner;
    const collectionBannerResizeObserver = 'ResizeObserver' in window
        ? new ResizeObserver(updateCollectionBannerHeight)
        : null;

    function updateCollectionBannerHeight() {
        if (collectionBanner) {
            document.documentElement.style.setProperty('--collection-banner-height', `${collectionBanner.offsetHeight}px`);
        } else {
            document.documentElement.style.removeProperty('--collection-banner-height');
        }
    }

    function observeCollectionBanner() {
        collectionBanner = document.querySelector('.main-collection-banner');
        collectionBannerResizeObserver?.disconnect();
        updateCollectionBannerHeight();
        if (collectionBanner) collectionBannerResizeObserver?.observe(collectionBanner);
    }

    observeCollectionBanner();
    window.addEventListener('resize', updateCollectionBannerHeight);
    document.addEventListener('shopify:section:load', observeCollectionBanner);

    // Alternate collection templates have suffixed body classes, such as collection-mobile-1-4-1-4.
    if (!hasClass(doenHeader, 'always-hover') || hasClass(body, 'collection') || collectionBanner) {
        var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.addEventListener('scroll', function (event) {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > 0) {
                addClass(document.querySelectorAll('.doen-header'), 'sticky');
                addClass(document.querySelectorAll('.doen-header'), 'hover');
            } else {
                removeClass(document.querySelectorAll('.doen-header'), 'sticky');
                removeClass(document.querySelectorAll('.doen-header'), 'hover');
            }
            const scrollThresholdPosition = collectionBanner ? st : lastScrollTop;
            if (st > lastScrollTop && scrollThresholdPosition > 85) {
                removeClass(document.body, 'scroll-up');
                addClass(document.body, 'scroll-down');
            } else {
                addClass(document.body, 'scroll-up');
                removeClass(document.body, 'scroll-down');
            }
            lastScrollTop = st;
        });
    }

    document.addEventListener('click', function(e) {
        if(e.target.closest('.doen-mobile-menu-open')) {
            e.preventDefault();
            let doenMobileHeader = document.querySelector('.doen-mobile-header');
            if (doenMobileHeader) {
                doenMobileHeader.classList.add('extended');
                let mobileMenuCloseButton = doenMobileHeader.querySelector('.doen-mobile-menu-close');
                mobileMenuCloseButton.classList.toggle('focus-ring-hidden', e.detail > 0);
                trapFocus(doenMobileHeader, mobileMenuCloseButton);
                setTimeout(function() {
                    if (mobileMenuCloseButton) {
                        mobileMenuCloseButton.focus();
                    }
                }, 250);
            }
        }
    });

    document.querySelectorAll('.doen-mobile-menu-close, .mobile-sub-nav a[data-handle="wishlist"]').forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            removeClass(document.querySelectorAll('.doen-mobile-header'), 'extended');
            removeClass(document.querySelectorAll('.doen-mobile-header'), 'top-nav-opened');
        });
    });

    document.querySelectorAll('.open-mobile-sub-nav').forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const handle = getDataAttribute(this, 'handle');
            
            if (hasClass(this, 'extended')) {
                const mobileNavItem = closest(this, '.mobile-nav-item');
                const mobileSubNav = mobileNavItem ? mobileNavItem.querySelector('div.mobile-sub-nav') : null;
                if (mobileSubNav) removeClass(mobileSubNav, 'active');
                
                const targetLink = document.querySelector('.mobile-nav-item__link[data-handle="' + handle + '"]');
                if (targetLink) {
                    targetLink.classList.toggle('focus-ring-hidden', e.detail > 0);
                    targetLink.focus();
                }
                
                const targetSubNav = document.querySelector('.mobile-sub-nav[data-trigger="' + handle + '"]');
                if (targetSubNav) targetSubNav.style.visibility = 'hidden';
                
                document.querySelectorAll('.doen-mobile-nav > .doen-mobile-nav__list .mobile-nav-item__link').forEach(link => {
                    setAttribute(link, 'tabindex', '0');
                });
                
                const subNavToggle = mobileNavItem ? mobileNavItem.querySelector('.open-mobile-sub-nav') : null;
                if (subNavToggle) setAttribute(subNavToggle, 'aria-expanded', "false");
                
                const doenMobileNav = closest(this, '.doen-mobile-nav');
                const openedLinks = doenMobileNav ? doenMobileNav.querySelectorAll('.mobile-nav-item__link.mobile-sub-nav-opened') : [];
                removeClass(openedLinks, 'mobile-sub-nav-opened');
                removeClass(document.querySelectorAll('.doen-mobile-header'), 'top-nav-opened');

                removeClass(this, 'extended');
            } else {
                const targetSubNav = document.querySelector('.mobile-sub-nav[data-trigger="' + handle + '"]');
                if (targetSubNav) {
                    addClass(targetSubNav, 'active');
                    targetSubNav.focus();
                    targetSubNav.style.visibility = 'visible';
                }
                
                document.querySelectorAll('.doen-mobile-nav > .doen-mobile-nav__list .mobile-nav-item__link').forEach(link => {
                    setAttribute(link, 'tabindex', '-1');
                });
                
                setAttribute(this, 'aria-expanded', "true");
                
                if (!closest(this, '.doen-mobile-utils')) {
                    addClass(document.querySelectorAll('.doen-mobile-header'), 'top-nav-opened');
                }
                addClass(this, 'extended');
            }
        });
    });

    document.querySelectorAll('.open-mobile-sub-sub-nav').forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const handle = getDataAttribute(this, 'handle');
            
            if (hasClass(this, 'extended')) {
                const mobileSubNav = closest(this, '.mobile-sub-nav');
                if (mobileSubNav) removeClass(mobileSubNav, 'mobile-sub-sub-nav-active');
                
                const listItem = closest(this, 'li');
                if (listItem) {
                    removeClass(listItem, 'has-sub-sub-nav-active');
                    const subSubNav = listItem.querySelector('div.mobile-sub-sub-nav');
                    if (subSubNav) removeClass(subSubNav, 'active');
                }
                
                const targetSubNav = document.querySelector('.mobile-sub-nav[data-trigger="' + handle + '"]');
                if (targetSubNav) targetSubNav.style.visibility = 'visible';
                
                const targetSubSubNav = document.querySelector('.mobile-sub-sub-nav[data-trigger="' + handle + '"]');
                if (targetSubSubNav) targetSubSubNav.style.visibility = 'hidden';
                
                const doenMobileNav = closest(this, '.doen-mobile-nav');
                const openedLinks = doenMobileNav ? doenMobileNav.querySelectorAll('.mobile-nav-item__link.mobile-sub-sub-nav-opened') : [];
                removeClass(openedLinks, 'mobile-sub-sub-nav-opened');

                removeClass(this, 'extended');
            } else {
                const mobileSubNav = closest(this, '.mobile-sub-nav');
                if (mobileSubNav) addClass(mobileSubNav, 'mobile-sub-sub-nav-active');
                
                const listItem = closest(this, 'li');
                if (listItem) addClass(listItem, 'has-sub-sub-nav-active');
                
                const doenMobileNav = closest(this, '.doen-mobile-nav');
                const navLinks = doenMobileNav ? doenMobileNav.querySelectorAll('.mobile-nav-item__link') : [];
                addClass(navLinks, 'mobile-sub-sub-nav-opened');
                
                const targetSubSubNav = document.querySelector('.mobile-sub-sub-nav[data-trigger="' + handle + '"]');
                if (targetSubSubNav) {
                    addClass(targetSubSubNav, 'active');
                    targetSubSubNav.style.visibility = 'visible';
                }
                addClass(this, 'extended');
            }
        });
    });
});

window.addEventListener('load', function () {
    document.querySelectorAll('.doen-meganav img').forEach(img => {
        img.removeAttribute('loading');
    });
});

document.querySelectorAll('.product .skip-to-content-link').forEach(link => {
    link.addEventListener('click', function (e) {
        const productInfoWrapper = document.getElementById('ProductInfoWrapper');
        if (productInfoWrapper) {
            productInfoWrapper.focus();
        }
    });
});

let clickGiftCard = document.querySelector('#upsell-gift');
if (clickGiftCard) {
    clickGiftCard.addEventListener('click', function () {
        setTimeout(function () {
            location.reload();
            localStorage.setItem("updatedCard", "Yes");
        }, 400);
    });
}

let checkStorage = localStorage.updatedCard
let openCartDrawer = document.querySelector('.cart-open');
if (checkStorage === 'Yes') {
    console.log('update cart for same day shipping')
    openCartDrawer.click();
    localStorage.removeItem("updatedCard");
}

document.addEventListener('click', function (e) {
    if (e.target.classList.contains('quick-buy__go-to-product') || e.target.closest('.quick-buy__go-to-product')) {
        e.preventDefault();
        if (openCartDrawer) {
            openCartDrawer.click();
        }
        if (document.querySelector('.quick-buy-overlay')) {
            if (window.closeQuickBuyOverlay) {
                window.closeQuickBuyOverlay(document.querySelector('.quick-buy-overlay'));
            } else {
                document.querySelector('.quick-buy-overlay').remove();
                document.body.classList.remove('noScroll');
            }
        }
    }
})

document.addEventListener('keydown', async (e) => {
    if (e.code === 'Enter' && e.target.classList.contains('card__size') && !e.target.classList.contains('is-unavailable')) {
        // Check max quantity limit
        const productId = e.target.dataset.productId ? parseInt(e.target.dataset.productId) : null;
        // Register max quantity from button if available
        if (productId && e.target.dataset.maxQuantity && window.MaxQuantityTracker) {
            window.MaxQuantityTracker.registerMaxQuantity(productId, parseInt(e.target.dataset.maxQuantity));
        }
        if (productId && window.MaxQuantityTracker) {
            // Re-init to get fresh cart data before checking
            await window.MaxQuantityTracker.init();
            if (!window.MaxQuantityTracker.canAddToCart(productId).allowed) {
                return; // Block add to cart
            }
        }
        
        var itemToAdd = {
            id: Number(e.target.dataset.variantId),
            quantity: 1
        }
        if (e.target.dataset.finalSale) {
            itemToAdd.properties = {
                'Final Sale': "This item is Final Sale"
            }
        }
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [itemToAdd]
            })
        })

        const data = await response.json();

        if (data) {
            // Update max quantity tracker
            if (window.MaxQuantityTracker) {
                window.MaxQuantityTracker.onCartAdd(data);
                
                // If max is now reached for this product, disable all buttons for it
                if (productId && window.MaxQuantityTracker.isMaxReached(productId)) {
                    document.querySelectorAll(`.card__size[data-product-id="${productId}"]`).forEach(btn => {
                        btn.classList.add('max-quantity-reached');
                        btn.setAttribute('disabled', 'disabled');
                    });
                    document.querySelectorAll(`.quick-buy-atc[data-product-id="${productId}"]`).forEach(btn => {
                        btn.classList.add('max-quantity-reached');
                    });
                }
            }
            openCartDrawer.click();
            loadEgCartDrawer();
        }
    }
});

document.addEventListener('click', async (e) => {
    if (e.target.classList.contains('card__size') && !e.target.classList.contains('is-unavailable')) {
        // Check max quantity limit
        const productId = e.target.dataset.productId ? parseInt(e.target.dataset.productId) : null;
        // Register max quantity from button if available
        if (productId && e.target.dataset.maxQuantity && window.MaxQuantityTracker) {
            window.MaxQuantityTracker.registerMaxQuantity(productId, parseInt(e.target.dataset.maxQuantity));
        }
        if (productId && window.MaxQuantityTracker) {
            // Re-init to get fresh cart data before checking
            await window.MaxQuantityTracker.init();
            if (!window.MaxQuantityTracker.canAddToCart(productId).allowed) {
                return; // Block add to cart
            }
        }
        
        var itemToAdd = {
            id: Number(e.target.dataset.variantId),
            quantity: 1
        }
        if (e.target.dataset.finalSale) {
            itemToAdd.properties = {
                'Final Sale': "This item is Final Sale"
            }
        }
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [itemToAdd]
            })
        })

        const data = await response.json();

        if (data) {
            // Update max quantity tracker
            if (window.MaxQuantityTracker) {
                window.MaxQuantityTracker.onCartAdd(data);
                
                // If max is now reached for this product, disable all buttons for it
                if (productId && window.MaxQuantityTracker.isMaxReached(productId)) {
                    document.querySelectorAll(`.card__size[data-product-id="${productId}"]`).forEach(btn => {
                        btn.classList.add('max-quantity-reached');
                        btn.setAttribute('disabled', 'disabled');
                    });
                    document.querySelectorAll(`.quick-buy-atc[data-product-id="${productId}"]`).forEach(btn => {
                        btn.classList.add('max-quantity-reached');
                    });
                }
            }
            openCartDrawer.click();
            loadEgCartDrawer();

            // Dispatch saved cart item event for customer accounts
            const addedItem = data.items[0];
            const gwCustomerAccounts = document.querySelector('gw-customer-accounts');
            if (gwCustomerAccounts) {
                const variantId = addedItem.variant_id;
                const productId = addedItem.product_id;
                if (!variantId && !productId) return;

                const event = new CustomEvent('gw:saved-items-from-cart', {
                    detail: {
                        productId: productId,
                        variantId: variantId,
                        target: e.target,
                        extra: addedItem
                    }
                });

                gwCustomerAccounts.dispatchEvent(event);
            }
        }
    }
})
// Add support for focus outlines on tab only
document.addEventListener('keydown', (event) => {
    // Check if the Tab key was pressed
    if (event.code === 'Tab') {
        // Add focus class to the body
        document.body.classList.add('show-focus-outlines');
    }

    if (event.target.classList.contains('aa-product')) {
        if (event.code === 'Enter') {
            event.target.closest('.aa-suggestion').click();
        }
    }

    if (event.target.classList.contains('aa-title') && (event.target.closest('.aa-page') || event.target.closest('.aa-article'))) {
        if (event.code === 'Enter') {
            event.target.closest('.aa-suggestion').click();
        }
    }
});


document.addEventListener('DOMContentLoaded', function () {

    const inputs = document.querySelectorAll('#create_customer input');

    inputs.forEach(input => {
        input.addEventListener('focus', function () {
            const parent = this.parentNode;
            const label = parent.querySelector('label');
            if (label) {
                label.classList.add('on-focus');
            }
        });

        input.addEventListener('blur', function () {
            if (this.value.length === 0) {
                const parent = this.parentNode;
                const label = parent.querySelector('label');
                if (label) {
                    label.classList.remove('on-focus');
                }
            }
        });
    });

    document.addEventListener('keyup', function (e) {
        if (e.key === "Escape") {
            let elements = document.getElementsByClassName("doen-meganav active");
            for (let el of elements) {
                el.classList.remove("active");
            }
        }
    });

    var checkPopupButton = setInterval(function () {
        const recommendationButton = document.querySelector('.recommendation-modal__button');
        if (recommendationButton) {
            console.log('Appeared')
            recommendationButton.setAttribute("tabindex", "-1");
            recommendationButton.setAttribute("id", "modal-button-continue");
            const modalButtonContinue = document.getElementById('modal-button-continue');
            if (modalButtonContinue) {
                modalButtonContinue.focus();
            }
            clearInterval(checkPopupButton);
        }
    }, 2000)



    const klavyioInputs = document.querySelectorAll('#email_signup_window_b input');

    klavyioInputs.forEach(input => {
        input.addEventListener('focus', function () {
            const parent = this.parentNode;
            const label = parent.querySelector('label');
            if (label) {
                label.classList.add('on-focus');
            }
        });

        input.addEventListener('blur', function () {
            if (this.value.length === 0) {
                const parent = this.parentNode;
                const label = parent.querySelector('label');
                if (label) {
                    label.classList.remove('on-focus');
                }
            }
        });
    });
});

document.addEventListener('keydown', function (e) {
    if (e.key == "Tab") {
        if (!e.shiftKey) {
            if (document.activeElement.dataset.handle == "currency-menu") {
                window.tabbedOnCurrencyMenu = true
            }
            if (window.tabbedOnLastSubNavItem) {
                e.target.closest('.mobile-nav-item').querySelector('.close-nav-layer').focus();
                window.tabbedOnLastSubNavItem = false;
            }
        }
        if (e.shiftKey) {
            if (document.activeElement.classList.contains("doen-mobile-menu-close")) {
                window.shiftTabbedOnCloseMobileMenu = true;
            }
        }
    }
});

document.addEventListener('keyup', function (e) {
    if (e.key == "Enter" || e.code == "Space") {
        if (e.target.classList.contains('.sheerness-container') || e.target.closest('.sheerness-container')) {
            document.querySelector('.sheerness-container').click();
        }
    }
    if (e.key == "Tab") {
        if (!e.shiftKey) {
            if (window.tabbedOnCurrencyMenu) {
                document.querySelector('.doen-mobile-menu-close').focus();
                window.tabbedOnCurrencyMenu = false
            }
            if (e.target.parentNode.classList.contains("last-item")) {
                window.tabbedOnLastSubNavItem = true;
            }
        }
        if (e.shiftKey) {
            if (window.shiftTabbedOnCloseMobileMenu) {
                if (!document.querySelectorAll('.doen-mobile-nav *[aria-expanded="true"]').length) {
                    document.querySelector('.mobile-nav-item a[data-handle="currency-menu"]').focus()
                } else {
                    if (document.querySelector('.has-sub-sub-nav-active')) {
                        document.querySelector('.has-sub-sub-nav-active .last-item a').focus();
                        window.tabbedOnLastSubNavItem = true;
                    } else {
                        document.querySelector('.nav-container.active > ul > .last-item a').focus();
                        window.tabbedOnLastSubNavItem = true;
                    }
                }
                window.shiftTabbedOnCloseMobileMenu = false;
            }
        }
    }
});
document.addEventListener('click', (e) => {
    // Remove focus class from the body
    document.body.classList.remove('show-focus-outlines');

    if (e.target.classList.contains('polaris-preferences-widget__close_button') || e.target.closest('.polaris-preferences-widget__close_button')) {
        var polarisConsentWidgets = document.getElementById('polaris-consent-widgets');
        if (polarisConsentWidgets) {
            const polarisPreferencesWidget = polarisConsentWidgets.querySelector('.polaris-preferences-widget');
            if (polarisPreferencesWidget) {
                polarisPreferencesWidget.removeAttribute('data-focus-trap-initialized');
            }

            removeTrapFocus();
        }

        document.getElementById('skip-to-content').focus();
    }
});

// Capture pointer intent before TrueVault moves focus to the preferences heading.
document.addEventListener('pointerdown', function (event) {
    const widget = event.target.closest('#polaris-consent-widgets');
    if (widget) widget.setAttribute('data-polaris-pointer-focus', '');
}, true);

document.addEventListener('keydown', function () {
    document.getElementById('polaris-consent-widgets')?.removeAttribute('data-polaris-pointer-focus');
}, true);

// Virtual clicks (for example, from assistive technology) have no pointer detail.
document.addEventListener('click', function (event) {
    if (event.detail === 0) {
        document.getElementById('polaris-consent-widgets')?.removeAttribute('data-polaris-pointer-focus');
    }
}, true);

document.addEventListener('focusout', function (event) {
    if (event.target.matches('#polaris-consent-widgets .polaris-modal__title')) {
        event.target.closest('#polaris-consent-widgets').removeAttribute('data-polaris-pointer-focus');
    }
});

function initializePolarisConsentWidget(widget) {
    widget.setAttribute('role', 'dialog');
    widget.setAttribute('aria-modal', 'true');
    widget.setAttribute('aria-label', 'Set Cookie Preferences');
    widget.style.zIndex = '9999999999';
    initializePolarisBannerClose(widget);
    const emailInput = widget.querySelector('[data-testid="oneClickOptOutEmailInput"]');
    const emailPlaceholder = document.querySelector('script[data-polaris-email-placeholder]')?.dataset.polarisEmailPlaceholder;
    if (emailInput && emailPlaceholder) {
        emailInput.placeholder = emailPlaceholder;
        emailInput.setAttribute('aria-label', emailPlaceholder);
    }
}

function initializePolarisBannerClose(widget) {
    const banner = widget.querySelector('.polaris-consent-widget');
    if (!banner) return;

    const customClose = banner.querySelector('.polaris-consent-widget__close_button');
    if (banner.querySelector('.polaris-modal, .polaris-consent-widget__title, [class*="_close_button-close_button-"]')) {
        customClose?.remove();
        return;
    }
    if (customClose) return;

    // TrueVault's headerless GDPR banner renders Manage, Decline, Accept in
    // that order. Reuse Decline's localized name and handler, so closing never
    // grants consent or bypasses TrueVault's consent persistence.
    const actions = banner.querySelector('.polaris-consent-widget__actions');
    const buttons = actions ? Array.from(actions.children).filter((element) => element.tagName === 'BUTTON') : [];
    if (buttons.length !== 3) return;

    const declineButton = buttons[1];
    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'polaris-button polaris-consent-widget__close_button';
    closeButton.setAttribute('aria-label', declineButton.textContent.trim());
    closeButton.title = declineButton.textContent.trim();
    closeButton.addEventListener('click', function () {
        declineButton.click();
    });
    banner.prepend(closeButton);
}

function trapPolarisPreferencesFocus(widget) {
    const preferencesWidget = widget.querySelector('.polaris-preferences-widget');
    const closeButton = widget.querySelector('.polaris-preferences-widget__close_button');

    if (
        !preferencesWidget ||
        !closeButton ||
        preferencesWidget.getClientRects().length === 0 ||
        preferencesWidget.hasAttribute('data-focus-trap-initialized')
    ) {
        return;
    }

    preferencesWidget.setAttribute('data-focus-trap-initialized', 'true');
    trapFocus(preferencesWidget, closeButton);
}

let observedPolarisConsentWidget = null;

const consentObserverPolaris = new MutationObserver(function () {
    const widget = document.getElementById('polaris-consent-widgets');
    if (!widget) return;

    initializePolarisConsentWidget(widget);
    trapPolarisPreferencesFocus(widget);

    if (observedPolarisConsentWidget !== widget) {
        consentObserverPolaris.disconnect();
        consentObserverPolaris.observe(widget, { childList: true, subtree: true });
        observedPolarisConsentWidget = widget;
    }
});

// Initial check in case it's already present
const consentWidgetPolaris = document.getElementById('polaris-consent-widgets');
if (consentWidgetPolaris) {
    initializePolarisConsentWidget(consentWidgetPolaris);
    trapPolarisPreferencesFocus(consentWidgetPolaris);
    consentObserverPolaris.observe(consentWidgetPolaris, { childList: true, subtree: true });
    observedPolarisConsentWidget = consentWidgetPolaris;
} else {
    consentObserverPolaris.observe(document, { childList: true, subtree: true });
}

document.addEventListener('focusin', function (e) {
    if (e.target.id === 'predictive_search_field') {
        const describedbyId = e.target.getAttribute('aria-describedby');
        if (describedbyId) {
            const describedElement = document.getElementById(describedbyId);
            if (describedElement) {
                describedElement.setAttribute('aria-hidden', 'false');
            }
        }
    }
});

document.addEventListener('focusout', function (e) {
    if (e.target.id === 'predictive_search_field') {
        const describedbyId = e.target.getAttribute('aria-describedby');
        if (describedbyId) {
            const describedElement = document.getElementById(describedbyId);
            if (describedElement) {
                describedElement.setAttribute('aria-hidden', 'true');
            }
        }
    }
});
